import HargaSatuanRataRataBarangjadi from "./HargaSatuanRataRataBarangjadi";

export default HargaSatuanRataRataBarangjadi;
